<template>
	
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
		</div>
		<Modal title="Title" v-model="modal9" :mask-closable="false" width="800">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>{{"设备MAC: " +this.mac}}</span>
        </p>
        <div style="text-align:left">
          <Table
            width="762"
            size="large"
            border
            stripe
            :loading="loading"
            :columns="columns2"
            :data="data2"
          ></Table>
          <br />
        </div>
        <div slot="footer"></div>
      </Modal>

	  <Modal title="Title" v-model="modal3" :mask-closable="false" width="800">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>{{"设备MAC: " +this.mac}}</span>
        </p>
        <div style="text-align:left">
          <Table
            width="762"
            size="large"
            border
            stripe
            :loading="loading3"
            :columns="columns3"
            :data="data3"
          ></Table>
          <br />
        </div>
        <div slot="footer"></div>
      </Modal>

		<Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>搜索</span>
			</p>
			<div style="padding-left: 20px;">
				<CheckboxGroup v-model="selectedConditions" class="check_group">
					<div>
						<Checkbox label="id">
							<span>消息编号</span>
						</Checkbox>
						<Input v-model="condition.id" placeholder="" />
					</div>
					<div>
						<Checkbox label="mac">
							<span>智能盒mac</span>
						</Checkbox>
						<Input v-model="condition.mac" placeholder="" />
					</div>
					<div>
						<Checkbox label="subType">
							<span>类型</span>
						</Checkbox>
						<Select v-model="condition.subType" placeholder="">
							<Option v-for="(item,index) in boxProfile.upload" :value="index">{{item.cn}}</Option>
						</Select>
					</div>
					<div>
						<Checkbox label="happenTime">
							<span>时间范围</span>
						</Checkbox>
						<Tooltip transfer placement="top" :disabled="condition.happenTimeRange[0] == ''">
							<div slot="content">
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[0])}}</span>
								<br />
								<span style="margin-left:50%">~</span>
								<br />
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[1])}}</span>
							</div>
							<DatePicker v-model="condition.happenTimeRange" type="daterange" split-panels
								placeholder=""></DatePicker>
						</Tooltip>
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
			</div>
		</Modal>


		<br />
		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="modelClick(row, index)"></Button>
			</template>
		</Table>
		<br />

		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "meter_work_info",
		
		data() {
			let that = this;
			return {
				boxProfile: {},
				data1: [],
				data2: [],
				data3: [],
				modal9 : false,
				modal3 : false,
				loading: true,
				loading3: true,
				mac:"",
				showDrawer: false,
				selectDataHtml: '',
				selectData: {},
				searchModal: false,
				currentPage: 1,
				pageSize: 30,
				totalRows: 0,
				selectedConditions: [],
				condition: {
					id: '',
					mac: '',
					subType: '',
					happenTimeRange: [],
				},
				requestBody: {},
				columns3: [
					{
						title: "日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							return h("div", params.row.timestamp);
						}
					},
					{
						title: "用气量",
						align: "center",
						render: function(h, params) {
							return h("div", params.row.gasDaily+" m³");
						}
					}
				],
				columns2: [
					{
						title: "日期",
						sortable: true,
						width: 200,
						align: "center",
						render: function(h, params) {
							return h("div", params.row.timestamp);
						}
					},
					{
						title: "气表总气量",
						align: "center",
						width: 140,
						render: function(h, params) {
							return h("div",params.row.gasTotal);
						}
					},
					{
						title: "日用气量",
						align: "center",
						width: 140,
						render: function(h, params) {
							return h("div", params.row.gasDaily);
						}
					},
					{
						title: "余量",
						align: "center",
						width: 140,
						render: function(h, params) {
							return h("div", params.row.remain);
						}
					},
					{
						title: "电池电压",
						align: "center",
						width: 140,
						render: function(h, params) {
							return h("div", params.row.voltage);
						}
					}
				],
				columns1: [
					{
						title: "消息编号",
						key: "id",
						align: "center",
					},
					{
						title: "智能盒mac",
						key: "mac",
						align: "center",
					},
					{
						title: "类型",
						key: "subType",
						align: "center",
						render: function(h, params) {
							let subType = that.boxProfile[params.row.mainType][params.row.subType];
							return h(
								"div",
								subType == null ? '未匹配：' + params.row.subType : subType.cn
							);
						}
					},
					{
						title: "上传时间",
						align: "center",
						render: function(h, params) {
							try {
								if (params.row.happenTime != undefined) {
									let timeStr = global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.happenTime)
									);
									return h("div", timeStr == "" ? "设备未校时" : timeStr);
								} else {
									return h(
										"div",
										global.dateFtt(
											"yyyy-MM-dd hh:mm:ss",
											new Date(params.row.receiveTime)
										)
									);
								}
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "操作",
						slot: "action",
						align: "center",
						width: 100

					}
				],
			};
		},
		created() {
			this.getBoxProfile()
			this.getMessage()
		},
		mounted() {

		},
		methods: {
			searchByConditionsView() {
				this.searchModal = true;
			},
			modelClick(row, index){
				if(row.subType == 'operationData'){
					this.getOperationData(row, index);
					this.mac=row.mac;
				}else if(row.subType == 'gasDetails'){
					this.getGasDetails(row, index);
					this.mac=row.mac;
				}else{
					this.showData(row, index);
				}
			},
			getOperationData(row, index){
				var that = this;
				that.requestBody["id"] =row.id;
				this.modal9 =true;
				$.ajax({
					url: "/api/meter/admin/message/getOperationData",
					type: "post",
					data: that.requestBody,
					success: function(res) {
						if (res.code == 0) {
							that.data2 = res.data;
							that.modal9 = true;
						} else {
							that.$Notice.error({
							title: "异常",
							desc: res.errorInfo
							});
						}
					},
					error: function(textStatus) {
					that.loading = false;
					that.$Notice.error({
						title: "异常",
						desc: "接口请求异常"
					});
					},
					complete: function() {
					that.loading = false;
					}
				});
			},
			getGasDetails(row, index){
				var that = this;
				that.requestBody["id"] =row.id;
				this.modal3 =true;
				$.ajax({
					url: "/api/meter/admin/message/getGasDetails",
					type: "post",
					data: that.requestBody,
					success: function(res) {
						if (res.code == 0) {
							that.data3 = res.data;
							that.modal3 = true;
						} else {
							that.$Notice.error({
							title: "异常",
							desc: res.errorInfo
							});
						}
					},
					error: function(textStatus) {
					that.loading3 = false;
					that.$Notice.error({
						title: "异常",
						desc: "接口请求异常"
					});
					},
					complete: function() {
					that.loading3 = false;
					}
				});
			},
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			getBoxProfile() {
				let that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/box/getProfile",
					async: false,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.boxProfile = result.data;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			showSearch() {
				this.searchModal = true;
			},
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.searchModal = false;
				this.currentPage = 1;
				this.getMessage();
			},
			getMessage() {
				let that = this;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/meter/admin/message/getUploadList?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize,
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "网络不通"
						});
					}
				});
			},
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.currentPage = index;
				this.loading = true;
				this.getMessage();
			},
			convertData(data, type, enums) {
				let result = data;
				if (type == "Time") {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if (type == "Enum") {
					result = enums[data] == null ? data : enums[data];
				}else if(type == "Select"){
					 result = data == 0 ? "充钱" : "充量";
				}
				return result;
			},
			showData(row, index) {
				// 遍历数据集拼接HTML
				let html = "";
				let that = this;

				let mainType = row.mainType;
				let subType = row.subType;

				try {
					html =
						"<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
					let amount = 0;
					let data = JSON.parse(row.content);
					Object.keys(data).forEach(function(key) {
						if (that.boxProfile[mainType] == null ||
							that.boxProfile[mainType][subType] == null ||
							that.boxProfile[mainType][subType]["params"][key] == null) {
							throw new Error("JSON格式错误");
						}

						if (amount % 2 == 0) {
							html += "<tr >";
						}
						let keyObj = that.boxProfile[mainType][subType]["params"][key];
						html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							keyObj.cn + "</td>";
						html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							that.convertData(data[key], keyObj.type, keyObj.enum) + " " + (keyObj.unit == null ?
								"" : keyObj.unit) + "</td>";
						if (amount % 2 == 1) {
							html += "</tr>";
						}
						amount++;
					});
					html += "</table>";
					that.selectDataHtml = html;
					that.selectData = data;
				} catch (err) {
					console.log(err);
					that.selectDataHtml = "<div>JSON格式错误</div>";
					that.selectData = row.content;
					html = that.selectDataHtml;
				}

				that.$Notice.open({
					title: "存储编号:" + row.id + "\t设备编号:" + row.mac,
					render: h => {
						return h("div", {
							on: {},
							style: {
								height: "100%",
								width: "100%"
							},
							domProps: {
								innerHTML: html
							}
						});
					},
					duration: 20
				});
			}
		},
	};
</script>

<style>
	.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 100px;
	}

	.check_group>div>div {
		width: 200px;
	}

	.ivu-date-picker {
		width: 100%;
	}
</style>
